import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { max } from "moment";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { CommonModule } from "@angular/common";
import { MatRadioButton, MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
@Component({
  selector: "app-dialog-threshold-settings",
  templateUrl: "./dialog-threshold-settings.component.html",
  styleUrls: ["./dialog-threshold-settings.component.scss"],
  standalone: true,
  imports: [CommonModule,MatRadioModule,FormsModule],
})
export class DialogThresholdSettingsComponent implements OnInit {
  public disableBtn: boolean = false;
  public changedData: any = [];
  changedObjects: any[] = [];
  metric_type: any;
  public saveButton: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DialogThresholdSettingsComponent>,
    private service: BackendApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}
  onSave(): void {
    const dataArray = [
      {
        index: 0,
        changedObject: this.data,
      },
    ];
    // Call a function to save the data
    this.dialogRef.close(dataArray); // Pass modified data back to parent component
  }
  saveMetricsData() {
    let th1Err = false;
    let th2Err = false;
    //check for threshold 2
    console.log(this.data.dataAll,'sssssssssss')
    for (let i = 0; i < this.data.dataAll.length; i++) {
      const {
        threshold_1,
        threshold_2,
        threshold_3,
        metric_name,
        base_value,
        max_value,
        max_counter
      } = this.data.dataAll[i];
      console.log(threshold_1, threshold_2, threshold_3, base_value, max_value,max_counter);
      if (base_value == null) {
        this.service.showError(
          `Base value should not be empty in Range`
        );
        th1Err = true;
        break;
      }
      if(max_counter=='' || max_counter==' ' || max_counter==null || max_counter==undefined){
        this.service.showError("Please enter valid counter value!")
        th1Err = true;
        th2Err = true;
        break;
      }
      if (max_value == null) {
        this.service.showError(
          `Max value should not be empty in Range`
        );
        th1Err = true;
        th2Err = true;
        break;
      }
      if (threshold_1 === null) {
        this.service.showError(`Green  should not be empty`);
        th1Err = true;
        th2Err = true;
        break;
      }
      if (threshold_2 == null) {
        this.service.showError(`Yellow should not be empty`);
        th2Err = true;
        break;
      }
      if (threshold_1 >= threshold_2) {
        this.service.showError(
          `Green should be less than Yellow`
        );
        th1Err = true;
        break;
      }
      // else if (base_value >= threshold_1) {
      //   this.service.showError(
      //     `base value should be less than green.`
      //   );
      //   th1Err = true;
      //   break;
      // }
       else if (threshold_1 >= threshold_3) {
        this.service.showError(
          `Green should be less than Yellow`
        );
        th1Err = true;
        break;
      }
      //check for threshold 2
      if (threshold_2 >= threshold_3) {
        this.service.showError(
          `Yellow should be less than 100`
        );
        th2Err = true;
        break;
      } else if (threshold_2 <= threshold_1) {
        this.service.showError(
          `Yellow should be more than green`
        );
        th2Err = true;
        break;
      }

      //check for range
      if (base_value >= max_value) {
        this.service.showError(
          `Base value should be less than max value in Range`
        );
        th1Err = true;
        break;
      } else if (max_value < base_value) {
        this.service.showError(
          `Max value should be more than base value in Range`
        );
        th1Err = true;
        break;
      }
    }
    if (th1Err || th2Err) return;
    else {
      this.dialogRef.close(this.changedObjects);
    }
  }

  //for updated object
  // updateData(event, index: number) {

  //   const changedObject = { ...this.data.dataAll[index] };
  //   const existingIndex = this.changedObjects.findIndex(
  //     (obj) => obj.index === index
  //   );
  //   if (existingIndex !== -1) {
  //     this.changedObjects[existingIndex] = { index, changedObject };
  //   } else {
  //     this.changedObjects.push({ index, changedObject });
  //   }
  //   console.log(this.changedObjects);
  // }
  // updateData(event: Event, index: number) {
  //   const inputElement = event.target as HTMLInputElement;
  //   const newValue = parseInt(inputElement.value, 10);
  //   if (index == 0) {
  //     if (newValue >= this.data.dataAll[index].threshold_2) {
  //       this.data.dataAll[index].threshold_1 =
  //         this.data.dataAll[index].threshold_2 - 1;
  //       inputElement.value = (
  //         this.data.dataAll[index].threshold_2 - 1
  //       ).toString();
  //       this.disableBtn = true;
  //     } else {
  //       this.data.dataAll[index].threshold_1 = newValue;
  //       this.disableBtn = false;
  //     }
  //   } else if (index == 1) {
  //     if (newValue >= this.data.dataAll[index].threshold_3) {
  //       this.data.dataAll[index].threshold_2 =
  //         this.data.dataAll[index].threshold_3 - 1;
  //       inputElement.value = (
  //         this.data.dataAll[index].threshold_3 - 1
  //       ).toString();
  //       this.disableBtn = true;
  //     } else {
  //       this.data.dataAll[index].threshold_2 = newValue;
  //       this.disableBtn = false;
  //     }
  //   }

  //   console.log("Input event fired at index:", index);
  //   console.log(this.data.dataAll[index]);
  //   console.log("Button disabled:", this.disableBtn);
  // }
  // updateData(event: Event, index: number) {
  //   this.metric_type=this.data.dataAll[index].metric_type;
  //   //  if (this.data.dataAll[index].threshold_1 >= this.data.dataAll[index].threshold_3) {
  //   //   console.log('enernenen');
  //   //   this.service.showError(
  //   //     `${this.metric_type}: Green should be less than Yellow`
  //   //   );
  //   //  let th1Err = true;
  //   //   // break;
  //   // }
  //   const inputElement = event.target as HTMLInputElement;
  //   const newValue = parseInt(inputElement.value, 10);

  //   // if (inputElement.name === "threshold_1") {
  //   //   if (newValue >= this.data.dataAll[index].threshold_2) {
  //   //     this.data.dataAll[index].threshold_1 =
  //   //       this.data.dataAll[index].threshold_2 - 1;
  //   //     inputElement.value = (
  //   //       this.data.dataAll[index].threshold_2 - 1
  //   //     ).toString();
  //   //     this.service.showError("Value should be less than yellow threshold");
  //   //   } else if (newValue <= 0) {
  //   //     this.data.dataAll[index].threshold_1 = 1;
  //   //     inputElement.value = "0";
  //   //     this.service.showError("Value must be positive");
  //   //   } else {
  //   //     this.data.dataAll[index].threshold_1 = newValue;
  //   //   }
  //   // }

  //   // if (inputElement.name === "threshold_2") {
  //   //   if (newValue <= this.data.dataAll[index].threshold_1) {
  //   //     this.data.dataAll[index].threshold_2 = Math.min(
  //   //       this.data.dataAll[index].threshold_3 - 1,
  //   //       this.data.dataAll[index].threshold_1 + 1
  //   //     );
  //   //     inputElement.value = this.data.dataAll[index].threshold_2.toString();
  //   //     this.service.showError("Value must be larger than green threshold");
  //   //   } else if (newValue >= this.data.dataAll[index].threshold_3) {
  //   //     this.data.dataAll[index].threshold_2 = Math.max(
  //   //       this.data.dataAll[index].threshold_3 - 1,
  //   //       this.data.dataAll[index].threshold_1 + 1
  //   //     );
  //   //     inputElement.value = this.data.dataAll[index].threshold_2.toString();
  //   //     this.service.showError("Value must be smaller than 100");
  //   //   } else {
  //   //     this.data.dataAll[index].threshold_2 = newValue;
  //   //   }
  //   // }

  //   // if (inputElement.name == "range_start") {
  //   //   if (newValue >= this.data.dataAll[index].max_value) {
  //   //     this.data.dataAll[index].base_value =
  //   //       this.data.dataAll[index].max_value - 1;
  //   //     inputElement.value = this.data.dataAll[index].base_value.toString();
  //   //     this.service.showError(
  //   //       "Value must be smaller than " + this.data.dataAll[index].max_value
  //   //     );
  //   //   } else {
  //   //     this.data.dataAll[index].base_value = newValue;
  //   //   }
  //   // }
  //   // if (inputElement.name == "range_end") {
  //   //   if (newValue <= this.data.dataAll[index].base_value) {
  //   //     this.data.dataAll[index].max_value =
  //   //       this.data.dataAll[index].base_value + 1;
  //   //     inputElement.value = this.data.dataAll[index].max_value.toString();
  //   //     this.service.showError(
  //   //       "Value must be greater than " + this.data.dataAll[index].base_value
  //   //     );
  //   //   } else {
  //   //     this.data.dataAll[index].max_value = newValue;
  //   //   }
  //   // }
  //   const changedObject = { ...this.data.dataAll[index] };
  //   const existingIndex = this.changedObjects.findIndex(
  //     (obj) => obj.index === index
  //   );
  //   if (existingIndex !== -1) {
  //     this.changedObjects[existingIndex] = { index, changedObject };
  //   } else {
  //     this.changedObjects.push({ index, changedObject });
  //   }
  // }
 updateData(event: Event, index: number) {
  this.saveButton = true;
  this.metric_type = this.data.dataAll[index].metric_type;

  const inputElement = event.target as HTMLInputElement;
  const inputValue = inputElement.value.trim();
  const newValue = parseInt(inputValue, 10);
  console.log("NAME:"+inputElement.name+" VALUE:"+inputValue)
  // Handle invalid input (e.g., empty or non-numeric values)
  if (isNaN(newValue)) {
    this.service.showError(`${this.metric_type}: Please enter a valid number`);
    inputElement.value = inputValue; // Preserve existing user input for correction
    return;
  }

  const thresholds = this.data.dataAll[index];
  console.log("current thresholds: "); 
  console.log(thresholds)
  // Validation logic
  switch (inputElement.name) {
    case "threshold_1":
      if (newValue >= thresholds.threshold_2) {
        thresholds.threshold_1 = thresholds.threshold_2 - 1;
        inputElement.value = thresholds.threshold_1.toString();
        this.service.showError(`${this.metric_type}: Green should be less than Yellow`);
      } else if (newValue <= 0) {
        thresholds.threshold_1 = 1;
        inputElement.value = "1";
        this.service.showError(`${this.metric_type}: Value must be positive`);
      } else {
        thresholds.threshold_1 = newValue;
      }
      break;

    case "threshold_2":
      if (newValue <= thresholds.threshold_1) {
        thresholds.threshold_2 = thresholds.threshold_2;
        inputElement.value = thresholds.threshold_2.toString();
        this.service.showError(`${this.metric_type}: Yellow should not less than green`);
      } else if (newValue <= 0) {
        thresholds.threshold_2 =  thresholds.threshold_2.toString();
        inputElement.value = "1";
        this.service.showError(`${this.metric_type}: Value must be positive`);
      } else {
        thresholds.threshold_2 = newValue;
      }
      break;

    case "range_start":
      if (newValue < 0) {
        thresholds.base_value = 0;
        inputElement.value = thresholds.base_value.toString();
        this.service.showError(`${this.metric_type}: Value must be at least 0`);
      } else if (newValue >= thresholds.threshold_1) {
        thresholds.base_value = thresholds.threshold_1 - 1;
        inputElement.value = thresholds.base_value.toString();
        this.service.showError(`${this.metric_type}: Base value must be less than Green`);
      } else if (newValue >= thresholds.threshold_2) {
        thresholds.base_value = thresholds.threshold_2 - 1;
        inputElement.value = thresholds.base_value.toString();
        this.service.showError(`${this.metric_type}: Base value must be less than Yellow`);
      } else if (newValue >= thresholds.threshold_3) {
        thresholds.base_value = thresholds.threshold_3 - 1;
        inputElement.value = thresholds.base_value.toString();
        this.service.showError(`${this.metric_type}: Base value must be less than Red`);
      } else {
        thresholds.base_value = newValue;
      }
      break;

    case "range_end":
      if (newValue <= thresholds.base_value) {
        thresholds.max_value = thresholds.base_value + 1;
        inputElement.value = thresholds.max_value.toString();
        this.service.showError(`${this.metric_type}: Range end must be greater than range start`);
      }
      //  else if (newValue >= thresholds.threshold_3) {
      //   thresholds.max_value = thresholds.threshold_3 - 1;
      //   inputElement.value = thresholds.max_value.toString();
      //   this.service.showError(`${this.metric_type}: Range end must be less than Red`);
      // }
       else {
        thresholds.max_value = newValue;
      }
      break;

    case "counter":
      thresholds.max_counter = newValue;
      break;
    default:
      this.service.showError(`${this.metric_type}: Invalid field`);
  }

  // Track changes
  const changedObject = { ...thresholds };
  const existingIndex = this.changedObjects.findIndex((obj) => obj.index === index);

  if (existingIndex !== -1) {
    this.changedObjects[existingIndex] = { index, changedObject };
  } else {
    this.changedObjects.push({ index, changedObject });
  }
}

  
  
  
  onClose(): void {
    this.dialogRef.close();
  }
}
